/**
 * Title module.
 * @module video/Title
 */

import './style.css';
import tmpl from './main.ejs';
import Events from 'f.core.event';

/**
 * title组件
 */
class Title {
    /**
     * Creates an instance of Title.
     * @param {string} title 显示的内容
     */
    constructor({title, danmakuSet}) {
        /**
         * 默认弹幕开启
         */
        this.danmuStatus = 'open';
        if (typeof danmakuSet != 'undefined') {
            this.danmuStatus = danmakuSet.isOpen == 1 ? 'open' : 'close';
        };
        this.init({title});
    }

    /**
     * 初始化
     *
     * @param {object} options
     * @param {string} options.title 要显示的内容
     */
    init(options) {
        this.initDom();
        this.initCompontent(options.title);
        this.initEvent();
    }

    /**
     * 初始化组件
     *
     * @param {any} content
     */
    initCompontent(content) {
        this.title.html(content);
    }

    /**
     * 初始化dom
     */
    initDom() {
        this.el = $(tmpl())[0];
        this.title = $(this.el).find('#js_siderTop_title');
        this.baifen = $(this.el).find('#js_siderTop_scale');
        this.control = $(this.el).find('.siderTopControl');
        this.time = $(this.el).find('#js_siderTop_time');

        /**
         * 弹幕按钮
         */
        this.vB_switch = $(this.el).find('.v_switch');
    }

    /**
     * 初始化事件
     */
    initEvent() {
        const _this = this;

        /**
         * 弹幕开关
         */
        this.vB_switch.on('click', () => {
            if (_this.danmuStatus == 'open') {
                _this.changeDanmu('close');
                _this.trigger('close');
            } else {
                _this.changeDanmu('open');
                _this.trigger('open');
            }
        });

        this.baifen.on('click', e => {
            let ev = e || window.event;
            const target = ev.target || ev.srcElement;
            if (target.nodeName.toLowerCase() == 'li') {
                if (target.className == 'current') return;
                _this.trigger('changeVideoSize', target);
            }
        });

        this.control.on('click', e => {
            let ev = e || window.event;
            const target = ev.target || ev.srcElement;
            if (target.nodeName.toLowerCase() == 'li') {
                if (target.className == 'current') return;
                // console.log(target);
                const tag = target.getAttribute('data-tag');
                // console.log(tag);
                switch (tag) {
                    /**
                     * 重新获取数据
                     */
                    case 'replay':
                        break;

                    /**
                     * 换节目
                     */
                    case 'menu':
                        _this.trigger('listshow', 'list');
                        break;

                    /**
                     * 下载
                     */
                    case 'down':
                        _this.trigger('listshow', 'download');
                        break;

                    /**
                     * 分享
                     */
                    case 'share':
                        _this.trigger('listshow', 'share');
                        break;

                    default:
                        break;
                }
            }
        });
    }

    /**
     * 切换弹幕状态
     *
     * @param {string} status 状态
     */
    changeDanmu(status) {
        if (status === 'open') {
            this.vB_switch.addClass('v_switchon');
            this.danmuStatus = 'open';
        } else {
            this.vB_switch.removeClass('v_switchon');
            this.danmuStatus = 'close';
        }
    }

    /**
     * 显示时间
     */
    showTime() {
        this.time.html(new Date().formatNowTime('hh:mm'));
    }

    /**
     * 隐藏组件
     */
    hide() {
        this.el.style.display = 'none';
    }

    /**
     * 显示组件
     */
    show() {
        this.el.style.display = 'block';
    }

    /**
     * 渲染组件
     *
     * @param {HTMLELEMENT} parentNode
     */
    renderTo(parentNode) {
        parentNode.appendChild(this.el);
    }

    /**
     * 销毁组件
     */
    destory() {
        this.el.parentNode.removeChild(this.el);
    }
}

Events.mixTo(Title);
export default Title;



// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/modules/title/index.js